export default "__VITE_ASSET__CqlQuhe9__"